export { default, default as Interaction } from './Interaction'
export * as InteractionStyles from './styles/Interaction.style'

export type { Interactions, InteractionProps, InteractionEvent, InteractionKeyboardEvent, InteractionTouchEvent } from './Interaction.types'

export type { StyledInteractionProps } from './styles/Interaction.style.types'
